import { jsx as _jsx } from "react/jsx-runtime";
import React, { createContext, useMemo } from 'react';
import { NotImplementedStorage } from '../../services';
export var StorageContext = createContext({
    storage: new NotImplementedStorage(),
});
export var StorageProvider = function (_a) {
    var children = _a.children, StorageImplementation = _a.StorageImplementation, storageInstance = _a.storageInstance;
    var storage = useMemo(function () {
        if (storageInstance) {
            return storageInstance;
        }
        if (StorageImplementation) {
            return new StorageImplementation();
        }
        throw new Error('No instance found, should exist at least one between StorageImplementation or storageInstance');
    }, [StorageImplementation, storageInstance]);
    return (_jsx(StorageContext.Provider, { value: { storage: storage }, children: children }));
};
